<template>
  <div class="footercss">
    <footer id="colophon" class="site-footer">
        <div class="container-fluid">
          <div class="row">
            <div class="col left-side">
              <div class="row">
                <div class="col-md-4">
                  <a href="/" class="custom-logo-link" rel="home" itemprop="url">
                    <img
                      src="../../assets/images/LogoIberoHorizontal.png"
                      class="custom-logo"
                      alt="Corporación Universitaria Iberoamericana"
                      itemprop="logo"
                    />
                  </a>
                  <a href="https://www.ibero.edu.co/tratamiento-uso-datos-personales" target="_blank">Tratamiento de datos personales</a>
                  <a href="https://www.ibero.edu.co/politica-proteccion-de-datos-personales" target="_blank">Poltica de protección de detos personales</a>
                  <a href="http://ibero.edu.co/politica-de-cookies" target="_blank">Política de cookies</a>
                </div>
                <div class="col-md-4">
                  <li><strong>Sede Principal</strong></li>
                  <li>Calle 67 # 5-27 <br/> Bogotá, Colombia</li>
                  <li><strong>Sede 23</strong></li>
                  <li>Carrera 16 # 79 - 34 <br/> Bogotá, Colombia</li>
                  <li>+601 742 65 82</li>
                </div>
                <div class="col-md-4">
                  <li><strong>Servicio al Estudiante:</strong></li>
                  <li>+601 746 68 76 <br/> servicioalestudiante@ibero.edu.co</li>
                  <li>Correo de notificaciones judiciales:<br/> <br/>
                    <a href="mailto:notificacionjudicial@ibero.edu.co" style="color: #fff;"
                    rel="noreferrer noopener" target="_blank" title="mailto:notificacionjudicial@ibero.edu.co">notificacionjudicial@ibero.edu.co</a>
                  </li>
                </div>
              </div>
            </div>
            <div class="col right-side d-flex">
              <div class="right-content w-100">
                <div class="right-top d-flex align-items-start">
                  <!-- Certificaciones -->
                  <div class="certifications">
                    <div class="cert-title">Certificaciones</div>
                    <div class="cert-images">
                      <img src="https://www.ibero.edu.co/themes/custom/iberotheme/images/footer-icons/ISO-ICONTEC-IQNET-2023-img.png" alt="cert1" />
                    </div>
                  </div>
                  <div class="socials">
                    <div class="social-title">Redes sociales</div>
                    <div class="social-icons">
                      <a href="https://www.facebook.com/LaIberoU/" aria-label="facebook" class="social-icon" target="_blank"><i class="fa fa-facebook"></i></a>
                      <a href="https://x.com/LaIberoU_" aria-label="twitter" class="social-icon" target="_blank"><i class="fa fa-twitter"></i></a>
                      <a href="https://www.youtube.com/channel/UC68bjC1Ed6ei66zyCICalJA" aria-label="youtube" class="social-icon" target="_blank"><i class="fa fa-youtube-play"></i></a>
                      <a href="https://www.instagram.com/laiberou/" aria-label="instagram" class="social-icon"><i class="fa fa-instagram" target="_blank"></i></a>
                    </div>
                  </div>
                </div>
                <div class="right-separator" role="separator" aria-hidden="true"></div>
                <div class="right-legal">
                  <p>Corporación Universitaria Iberoamericana</p>

                  <p>Personería jurídica no. 482 del 28 de enero de 1982</p>

                  <p>Vigilada Ministerio de Educación Nacional</p>

                  <p class="copyright">
                    IBERO 2024 ©<br/>
                    TODOS LOS DERECHOS RESERVADOS
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
    </footer>
  </div>
</template>

<script>
  export default {
    name: "Ibero"
  };
</script>

<style scoped>
.site-footer {
  width: 100%;
  padding: 0;
  margin: 0;
}

.site-footer .container-fluid,
.site-footer .row {
  margin: 0;
  padding: 0;
  width: 100%;
}
.site-footer .row {
  display: flex;
  flex-wrap: wrap;
}

.left-side {
  background: #222222;
  color: #fff;
  padding: 40px 20px 40px 100px !important;
  flex: 0 0 65%;
  max-width: 65%;
}

.left-side .row {
  display: flex;
  justify-content: flex-start;
  width: 100%;
}

.left-side .col-md-4 {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-right: 15px;
}

.custom-logo {
  width: 180px;
  height: auto;
  margin-bottom: 20px;
}

.left-side a {
  display: block;
  color: #747679;
  font-size: 17px;
  text-decoration: none;
  margin-bottom: 8px;
  line-height: 1.2;
}

.left-side li {
  list-style: none;
  font-size: 13px;
  margin-bottom: 8px;
}

.right-side {
  background-color: #4A4848;
  color: #fff;
  flex: 0 0 35%;
  max-width: 35%;
  padding: 40px 50px !important;
  display: flex;
  flex-direction: column;
}

.right-content {
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
}

.right-top {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  gap: 40px;
  align-items: flex-start;
  width: 100%;
  margin-bottom: 20px;
}

.certifications {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.cert-title, .social-title {
  font-weight: bold;
  margin-bottom: 10px;
  font-size: 14px;
}

.cert-images {
  display: flex;
  align-items: center;
  gap: 10px;
}

.cert-images img {
  height: 70px;
  width: auto;
}

.cert-code {
  font-size: 12px;
}

.socials {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.social-icons {
  display: flex;
  gap: 10px;
}

.social-icon {
  color: #fff;
  font-size: 16px !important;
  text-decoration: none;
}
.right-separator {
  width: 100%;
  height: 1px;
  background-color: rgba(255, 255, 255, 0.2);
  margin: 20px 0;
}

.right-legal {
  text-align: left;
  font-size: 12px;
  line-height: 1.4;
}

.right-legal p {
  margin: 0 0 5px 0;
  color: #fff;
  padding-bottom: 10px;
}

.copyright {
  margin-top: 15px !important;
  font-weight: bold;
  text-transform: uppercase;
  color: #fff !important;
}

/* FontAwesome Shim (si no carga externamente) */
.fa {
  display: inline-block;
  font: normal normal normal 14px/1 FontAwesome;
}

/* MEDIA QUERIES PARA MOVIL */
@media (max-width: 992px) {
  .left-side, .right-side {
    flex: 0 0 100%;
    max-width: 100%;
    padding: 30px !important;
  }
  
  .right-top {
    flex-wrap: wrap;
    gap: 20px;
  }
}
</style>